import React from 'react';
import { colors } from '../../colors';

interface Props {
  stableBalancePercentage: number;
  assetBalancePercentage: number;
}

const BalanceIndciator = (props: Props) => {
  const { stableBalancePercentage, assetBalancePercentage } = props;

  return (
    <div
      style={{
        display: 'flex',
        height: 16,
        width: 80,
        borderRadius: 6,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <div
        style={{
          backgroundColor: colors.green,
          width: `${
            assetBalancePercentage +
            (assetBalancePercentage > stableBalancePercentage ? 0 : 20)
          }%`,
          height: '100%',
          borderRadius:
            assetBalancePercentage > stableBalancePercentage ? 8 : 8,
          zIndex: assetBalancePercentage > stableBalancePercentage ? 3 : 2,
          position: 'absolute',
          left: 0,
        }}
      />
      <div
        style={{
          backgroundColor: colors.red,
          width: `${
            stableBalancePercentage +
            (assetBalancePercentage < stableBalancePercentage ? 0 : 20)
          }%`,
          height: '100%',
          borderRadius:
            assetBalancePercentage < stableBalancePercentage ? 8 : 8,
          zIndex: assetBalancePercentage < stableBalancePercentage ? 3 : 2,
          position: 'absolute',
          right: 0,
        }}
      />
    </div>
  );
};

export default BalanceIndciator;
